import { useStore } from '@/utils/vue-api';
import { computed } from 'vue';
import i18n, { ZH } from '@/locales';

export const useMarketStyle = () => {
	const marketStyles = {
		SH: 'background: rgba(242, 61, 61, 0.1); color: #f23d3d;',
		SZ: 'background: rgba(242, 61, 61, 0.1); color: #f23d3d;',
		HK: 'background: rgba(150, 115, 255, 0.1); color: #9673ff;',
		US: 'background: rgba(57, 100, 229, 0.1); color: #3964e5;'
	};

	const store = useStore();
	const getBaseData = computed(() => store.getters.getBaseData || {});
	const getUpperMarket = computed(() => getBaseData.value.market?.toUpperCase() || '');

	const bindMarketStyle = computed(() => {
		return marketStyles[getUpperMarket.value] || marketStyles['SH'];
	});

	// 涨跌颜色
	const upColor = i18n.locale === ZH ? '#fa4646' : '#30bf54';
	const downColor = i18n.locale === ZH ? '#30bf54' : '#fa4646';

	const bindTrendColorFunc = value => {
		if (typeof value !== 'number' || isNaN(value)) return '';
		return value > 0 ? `color: ${upColor};` : `color: ${downColor};`;
	};

	return {
		bindMarketStyle,
		bindTrendColorFunc
	};
};
